// extracted by mini-css-extract-plugin
module.exports = {"friend_list":"FreindList_friend_list__2khAL","item":"FreindList_item__2YPFy","status":"FreindList_status__2CTRm"};